/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusGrantPlanItem
 */
export interface BonusGrantPlanItem {
    /**
     * 计划ID
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    id?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    userId?: number;
    /**
     * 发放来源：1-赔偿金，2-充值赠送，3-活动赠送
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    source?: number;
    /**
     * 发放来源名称
     * @type {string}
     * @memberof BonusGrantPlanItem
     */
    sourceName?: string;
    /**
     * 发放方式：1-一次性，2-分批
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    grantWay?: number;
    /**
     * 发放方式名称
     * @type {string}
     * @memberof BonusGrantPlanItem
     */
    grantWayName?: string;
    /**
     * 发放总额
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    totalAmount?: number;
    /**
     * 每次发放金额
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    perGrantAmount?: number;
    /**
     * 间隔类型：1-按月，2-按天（一次性为null）
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    intervalType?: number;
    /**
     * 间隔类型名称
     * @type {string}
     * @memberof BonusGrantPlanItem
     */
    intervalTypeName?: string;
    /**
     * 每月几号发放（按月时）
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    dayOfMonth?: number;
    /**
     * 间隔天数（按天时）
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    intervalDays?: number;
    /**
     * 总期数
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    totalBatchCount?: number;
    /**
     * 已发期数
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    grantedBatchCount?: number;
    /**
     * 状态：1-进行中，2-已完成，3-已停止
     * @type {number}
     * @memberof BonusGrantPlanItem
     */
    status?: number;
    /**
     * 状态名称
     * @type {string}
     * @memberof BonusGrantPlanItem
     */
    statusName?: string;
    /**
     * 发放说明
     * @type {string}
     * @memberof BonusGrantPlanItem
     */
    remark?: string;
    /**
     * 创建时间
     * @type {string}
     * @memberof BonusGrantPlanItem
     */
    createTime?: string;
}

/**
 * Check if a given object implements the BonusGrantPlanItem interface.
 */
export function instanceOfBonusGrantPlanItem(value: object): value is BonusGrantPlanItem {
    return true;
}

export function BonusGrantPlanItemFromJSON(json: any): BonusGrantPlanItem {
    return BonusGrantPlanItemFromJSONTyped(json, false);
}

export function BonusGrantPlanItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusGrantPlanItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'source': json['source'] == null ? undefined : json['source'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'grantWay': json['grantWay'] == null ? undefined : json['grantWay'],
        'grantWayName': json['grantWayName'] == null ? undefined : json['grantWayName'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'perGrantAmount': json['perGrantAmount'] == null ? undefined : json['perGrantAmount'],
        'intervalType': json['intervalType'] == null ? undefined : json['intervalType'],
        'intervalTypeName': json['intervalTypeName'] == null ? undefined : json['intervalTypeName'],
        'dayOfMonth': json['dayOfMonth'] == null ? undefined : json['dayOfMonth'],
        'intervalDays': json['intervalDays'] == null ? undefined : json['intervalDays'],
        'totalBatchCount': json['totalBatchCount'] == null ? undefined : json['totalBatchCount'],
        'grantedBatchCount': json['grantedBatchCount'] == null ? undefined : json['grantedBatchCount'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusName': json['statusName'] == null ? undefined : json['statusName'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function BonusGrantPlanItemToJSON(json: any): BonusGrantPlanItem {
    return BonusGrantPlanItemToJSONTyped(json, false);
}

export function BonusGrantPlanItemToJSONTyped(value?: BonusGrantPlanItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'source': value['source'],
        'sourceName': value['sourceName'],
        'grantWay': value['grantWay'],
        'grantWayName': value['grantWayName'],
        'totalAmount': value['totalAmount'],
        'perGrantAmount': value['perGrantAmount'],
        'intervalType': value['intervalType'],
        'intervalTypeName': value['intervalTypeName'],
        'dayOfMonth': value['dayOfMonth'],
        'intervalDays': value['intervalDays'],
        'totalBatchCount': value['totalBatchCount'],
        'grantedBatchCount': value['grantedBatchCount'],
        'status': value['status'],
        'statusName': value['statusName'],
        'remark': value['remark'],
        'createTime': value['createTime'],
    };
}

